import React from "react";

export const BaseAuth: React.FC<any> = ({ children, tamanho }) => {
  return (
    <div className="panel-login middle-box"
      style={{
        width: tamanho
      }}>
      <div className="logo">
        <img src={require("../../../assets/logo.png")} alt="Logo da Faelce" />
      </div>

      <h4>Bem-vindo ao portal da Faelce</h4>

      {children}
    </div>
  );
};
